<template>
  <div>
    <div
      v-if="!isAuthenticated"
      class="row justify-around items-center"
    >
      <span>Skráðu þig inn til að setja í reikning</span>
      <q-btn
        class="q-pa-xs"
        color="secondary"
        label="Innskráning"
        @click="showDialog = true"
      />
    </div>
    <div
      v-else
      class="row justify-around items-center"
    >
      <span>Upphæð verður sett í reikning á kennitölu {{ userExternalId }}</span>
      <q-btn
        class="q-pa-xs"
        color="secondary"
        label="Breyta Notanda"
        @click="showDialog = true"
      />
    </div>
    <q-dialog
      v-model="showDialog"
      persistent
    >
      <q-card square>
        <q-card-section class="q-pa-xl">
          <q-btn
            v-close-popup
            class="absolute-top-right"
            icon="mdi-close"
            round
            flat
            @click="closeDialog"
          />

          <div v-if="showPhoneNumberDialog">
            <div class="row text-body1 q-mb-md">
              {{ $t('checkout.hintPhoneNumber') }}
            </div>

            <div class="row q-col-gutter-lg items-end justify-end">
              <div class="col-grow">
                <q-input
                  ref="phoneNumber"
                  v-model="phoneNumber"
                  type="tel"
                  class="text-body1"
                  :label="$t('user.phoneNumber')"
                  @keyup.enter="sendPhoneNumber"
                />
              </div>
              <div class="col-shrink">
                <q-btn
                  class="q-btn--primary"
                  :size="$q.platform.is.mobile ? 'md' : 'lg'"
                  :disable="phoneNumber.length < 4"
                  :label="$t('send')"
                  @click="sendPhoneNumber"
                />
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row text-body1 q-mb-md">
              {{ $t('checkout.hintVerificationCode') }}
            </div>

            <div class="row q-col-gutter-lg items-end justify-end">
              <div class="col-grow">
                <q-input
                  ref="verificationCode"
                  v-model="verificationCode"
                  class="text-body1"
                  :label="$t('user.verificationCode')"
                  @keyup.enter="sendVerificationCode"
                />
              </div>
              <div class="col-shrink">
                <q-btn
                  class="q-btn--primary"
                  :size="$q.platform.is.mobile ? 'md' : 'lg'"
                  :disable="verificationCode.length < 4"
                  :label="$t('send')"
                  @click="sendVerificationCode"
                />
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import errorDialog from 'quasar-pilot-core/src/mixins/errorDialog';
import actions from '../../lib/api/actions';

export default {
  name: 'InvoiceAuthForm',
  mixins: [errorDialog],

  data() {
    return {
      phoneNumber: '',
      verificationCode: '',
      showPhoneNumberDialog: null,
      showVerificationCodeDialog: null,
      showDialog: false,
      userExternalId: null,
      isAuthenticated: false,
    };
  },

  computed: {
  ...mapState('order', ['paymentData']),
  },

  watch: {
    showDialog() {
      this.showPhoneNumberDialog = true;
      this.$nextTick(() => {
        if (this.$refs.phoneNumber) {
          this.$refs.phoneNumber.$el.focus();
        }
      });
    },
  },

  methods: {
    ...mapMutations('application', ['blockInteraction', 'allowInteraction']),
    ...mapMutations('order', ['updatePaymentData']),
    closeDialog() {
      this.showDialog = false;
    },

    async sendPhoneNumber() {

      try {
        this.blockInteraction();
        await actions.authenticateUser({
          phone: this.phoneNumber,
          options: {
            skipSMS: false,
          },
        });

        this.showPhoneNumberDialog = false;

        if (!this.isLoggedIn) {
          this.showVerificationCodeDialog = true;
          this.$nextTick(() => {
            if (this.$refs.verificationCode) {
              this.$refs.verificationCode.$el.focus();
            }
          });
        }
      }
      catch (e) {
        this.showErrorDialog(e);
      }

      this.allowInteraction();
    },

    async sendVerificationCode() {
      try {
        this.blockInteraction();
        const response = await actions.authenticateUser({
          phone: this.phoneNumber,
          verificationCode: this.verificationCode,
        });

        if (response) {
          if (response.data.data.externalId) {
            this.updatePaymentData({
              phoneNumber: this.phoneNumber
            });
            this.$q.dialog({
              title: 'Reikningsviðskipti',
              message: `Upphæð verður sett í reikning á kennitölu ${response.data.data.externalId}`,
              ok: this.$t('OK'),
            });
            this.isAuthenticated = true;
            this.userExternalId = response.data.data.externalId
          }
          else {
            this.$q.dialog({
              title: 'Reikningsviðskipti',
              message: `Þessi notandi er ekki skráður í reikningsviðskipti`,
              ok: this.$t('OK'),
            });
          }
          this.showVerificationCodeDialog = false;
          this.closeDialog()
        }
      }
      catch (e) {
        this.showErrorDialog(e);
      }

      this.allowInteraction();
    },
  },
};
</script>
